import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';

import {
  LOAD_COURSES,
  //DELETE_ATTENDANCE,
} from './constants';

import {
  loadCoursesSuccess,
  loadCoursesError,
  /* deleteAttendanceSuccess,
  deleteAttendanceError, */
} from './actions';

// utils
import api from "utils/api";
const { endpoint } = api;
import _local from 'utils/localStorageUtils';

export function* loadMobileCourses(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { _id: userID, role } = currentUser;
    const { options } = action;


    let queryOptions = {
        ...options,
      },
      itemsList = false;

    if (role == 'teacher') {
      // we get the campaigns linked to the courses
      itemsList = yield requestWrapper(
        'POST',
        endpoint?.courses?.teacher?.attendancesList(userID),
        queryOptions,
        currentUser.token,
      );
    } else if (role == 'parent') {
      // we get the campaigns linked to the courses
      itemsList = yield requestWrapper(
        'POST',
        endpoint?.courses?.parent?.childrenAttendances(),
        queryOptions,
        currentUser.token,
      );
    }

    if (!itemsList?.data) {
      yield put(loadCoursesSuccess(false));
    } else {
      yield put(loadCoursesSuccess(itemsList?.data));
    }
  } catch (error) {
    yield put(loadCoursesError(error));
  }
}

export default function* attendanceSaga() {
  yield takeLatest(LOAD_COURSES, loadMobileCourses);
  // yield takeLatest(DELETE_ATTENDANCE, deleteAttendance);
}
